export const USER_ROLES = {
    ADMIN: "ADMIN",
    USER: "USER",
    VIEWER: "VIEWER",
    SUPERADMIN: "SUPERADMIN"
};
export const AUTH_CHALLENGES = {
    NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
    SOFTWARE_TOKEN_MFA: "SOFTWARE_TOKEN_MFA",
    SMS_MFA: "SMS_MFA",
    MFA_SETUP: "MFA_SETUP"
};
